import React, { useEffect } from 'react';
import { SelectInput, TextInput, required, useTranslate } from 'react-admin';
import { useFormState, useForm } from 'react-final-form';
import Button from '@material-ui/core/Button';

import { GridForm, GridInput, FormGroupGrid } from '../../../components/GridForm';
import { DateInput } from '../../../components/inputs';
import { AdminActionName } from '../../../entities/AdminActionName';
import { JsonTextInput } from 'components/fields/JsonTextInput';
import { useEnumSelectChoices } from 'components/_helpers/useEnumSelectChoices';
import { OrderDocumentOutputType } from 'entities/OrderDocumentOutputType';


const taskCallTypeChoices = [
	{id: "apply", name: "apply"},
	{id: "async-apply", name: "async-apply"},
	{id: "send-task", name: "send-task"},
];

const DocumentOutputType = {
	loading: OrderDocumentOutputType.loading,
	unloading: OrderDocumentOutputType.unloading,
};

const AdminActionSection = ({onApply, children, ...props}) => {
	const { values } = useFormState();
	const t = useTranslate();

	const handleClickApply = (ev) => {
		const res = {};
		const arrayChildren = React.Children.toArray(children);
		React.Children.map(arrayChildren, (child, index) => {
			const key = child.props["source"];
			res[key] = values[key] !== undefined ? values[key] : null
		});	
		onApply(res);
	};

	return (
		<FormGroupGrid xs={12} title={t('resources.admin-actions.fields.constructor_title')} {...props}>
			{children}
			<Button variant="contained" color="primary" onClick={handleClickApply}>
				{t('osfc.buttons.apply')}
			</Button>
		</FormGroupGrid>
	);
};

export const AdminActionCreateForm = (props) => {
	const form = useForm();
	const { values } = useFormState();
	const adminActionNameChoices = useEnumSelectChoices(AdminActionName, '', false);
	const docOutputTypeChoices = useEnumSelectChoices(DocumentOutputType, '', false);

	const handleApply = (res) => {
		const json = JSON.stringify(res);
		form.change("data", json)
	};

	const handleActionNameChange = (event) =>{
		for (const key of Object.keys(values)) {
			if (key !== "name") {
				form.change(key, null)
			}
		}
	};

	useEffect(() => {
		if (values["name"] === AdminActionName.run_task) {
			form.change("params", {args: [], kwargs: {}});
		}
	}, [values["name"]]);

	return (
		<GridForm {...props}>		
			<GridInput sm={12} component={SelectInput} source='name' choices={adminActionNameChoices} onChange={handleActionNameChange} validate={[required()]} />

			{values["name"] === AdminActionName.regen_out_doc ?
			<AdminActionSection onApply={handleApply}>
				<GridInput xs={12} sm={6} component={DateInput} source="date_from" />
				<GridInput xs={12} sm={6} component={DateInput} source="date_to" />
				<GridInput xs={12} sm={8} component={SelectInput} source="doc_out_type" choices={docOutputTypeChoices} />
			</AdminActionSection> : null}

			{values["name"] === AdminActionName.try_gen_out_doc ?
			<AdminActionSection onApply={handleApply}>
				<GridInput xs={12} sm={6} component={DateInput} source="date_from" />
				<GridInput xs={12} sm={6} component={DateInput} source="date_to" />
				<GridInput xs={12} sm={8} component={SelectInput} source="doc_out_type" choices={docOutputTypeChoices} resettable={false} validate={[required()]} />
			</AdminActionSection> : null}	

			{values["name"] === AdminActionName.run_task ?
			<AdminActionSection onApply={handleApply}>
				<GridInput xs={12} sm={6} component={SelectInput} source="call_type" choices={taskCallTypeChoices} validate={[required()]} />
				<GridInput xs={12} sm={6} component={TextInput} source="task_name" validate={[required()]} />
				<GridInput xs={12} sm={6} component={JsonTextInput} source="params" jsonString={false} label="resources.admin-actions.fields.params" />
			</AdminActionSection> : null}	

			<GridInput sm={12} component={TextInput} source='data' multiline rows={6} disabled 
				validate={values["name"] !== AdminActionName.regen_out_doc_with_empty_data ? [required()] : undefined} />		
		</GridForm>
	);
};